import { faUserShield } from '@fortawesome/pro-light-svg-icons/faUserShield'

export default [
  faUserShield
]
